<template lang="pug">
.c-progress-form__element
  label.c-progress-form__title(v-html="$t('profiles.questions.house_owner')")
  .c-multiple-choice
    .row.c-multiple-choice__options
      .column.c-multiple-choice__item.c-multiple-choice__item--icon
        input.c-multiple-choice__radio(type="radio" :value="true" name="user[user_detail_attributes][house_owner]" id="user_user_detail_attributes_house_owner_owner" v-model="houseOwner")
        label.c-multiple-choice__label(for="user_user_detail_attributes_house_owner_owner")
          Icon(icon="choice-owner" classes="c-multiple-choice__icon")
          | {{$t('profiles.questions.house.owner')}}
      .column.c-multiple-choice__item.c-multiple-choice__item--icon
        input.c-multiple-choice__radio(type="radio" :value="false" name="user[user_detail_attributes][house_owner]" id="user_user_detail_attributes_house_owner_renter" v-model="houseOwner")
        label.c-multiple-choice__label(for="user_user_detail_attributes_house_owner_renter")
          Icon(icon="choice-rent" classes="c-multiple-choice__icon")
          | {{$t('profiles.questions.house.renter')}}
    transition(name="fade")
      .c-progress-form__additional-questions.is-visible(v-if="houseOwner")
        HouseSubQuestions(v-for="subQuestion in subQuestions" :name="subQuestion" :key="subQuestion")

</template>

<script>
import Icon from '../shared/Icon'
import HouseSubQuestions from './HouseSubQuestions'

export default {
  components: {
    Icon,
    HouseSubQuestions
  },
  data () {
    return {
      subQuestions: [
        'foreseen_house_work',
        'has_mortgage',
        'own_primary_house',
        'own_secondary_house',
        'own_apartment_building'
      ]
    }
  },
  computed: {
    houseOwner: {
      get () {
        return this.$store.state.person.house_owner
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: 'house_owner', value: value})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profiles/House.vue